import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const statusChart = `stateDiagram-v2
    [*] --> 草稿 : MRP 自动创建\n或手工创建
    草稿 --> 有效 : 开工
    有效 --> 有效 : 暂停 → 恢复
    有效 --> 完工 : 完工（归档冻结）
    有效 --> 无效 : 关闭
    完工 --> 有效 : 返工出库`;
const statusColumns = [{
  title: '状态',
  dataIndex: 'status'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '你能做什么',
  dataIndex: 'action'
}, {
  title: '条件',
  dataIndex: 'condition'
}];
const statusData = [{
  status: '草稿',
  meaning: 'MRP 创建或手工创建，尚未开始',
  action: '查看、删除',
  condition: '—'
}, {
  status: '有效（生产中）',
  meaning: '正在生产',
  action: '领料、补料、暂停、完工、关闭',
  condition: '齐套分析通过后'
}, {
  status: '暂停',
  meaning: '临时停工（缺料/设备故障等）',
  action: '恢复生产',
  condition: '点击暂停'
}, {
  status: '完工',
  meaning: '生产完成，工单归档冻结',
  action: '只读查看',
  condition: '产成品已入库'
}, {
  status: '无效',
  meaning: '工单被关闭（取消/错误）',
  action: '只读查看',
  condition: '点击关闭'
}];
const dailyFlowChart = `graph TD
    A["拿到工单"] --> B["齐套分析\\n料备齐了吗?"]
    B --> C{"齐套?"}
    C -->|"是"| D["点击 开工"]
    C -->|"否"| E["缺料等待\\n或催采购/上游"]
    E --> D
    D --> F["领料"]
    F --> G["生产"]
    G --> H{"情况?"}
    H -->|"正常"| I["产成品入库\\n→ 完工"]
    H -->|"料坏了/不够"| J["补料"]
    J --> G
    H -->|"料多了"| K["退料"]
    K --> G
    H -->|"设计变了"| L["ECN 变更"]
    L --> G
    H -->|"临时停工"| M["暂停"]
    M --> N["恢复"]
    N --> G

    style D fill:#E8F5E9,stroke:#4CAF50
    style I fill:#E8F5E9,stroke:#4CAF50
    style J fill:#FFF3E0,stroke:#FF9800
    style L fill:#FFEBEE,stroke:#F44336`;
const materialColumns = [{
  title: '操作',
  dataIndex: 'op'
}, {
  title: '场景',
  dataIndex: 'scene'
}, {
  title: '说明',
  dataIndex: 'desc'
}];
const materialData = [{
  op: '领料',
  scene: '开工后需要原材料',
  desc: '从仓库领出物料到产线，系统记录出库'
}, {
  op: '退料',
  scene: '领多了用不完',
  desc: '多余的物料退回仓库，系统记录入库'
}, {
  op: '补料',
  scene: '生产中物料损坏/不够',
  desc: '创建补料需求单（走审批），批准后仓库发料'
}];
const ecnChart = `graph LR
    A["创建变更单"] --> B["填写变更明细\\n（增/减/改物料）"]
    B --> C["发布变更"]
    C --> D["审批"]
    D --> E{"结果"}
    E -->|"批准"| F["系统自动调整\\n工单物料明细"]
    E -->|"驳回"| G["修改后重新发布"]`;
const sections = [{
  id: 'status-flow',
  label: '工单状态流转'
}, {
  id: 'daily-flow',
  label: '日常操作流程'
}, {
  id: 'material',
  label: '领料、退料、补料'
}, {
  id: 'ecn',
  label: 'ECN 工程变更'
}, {
  id: 'sub-order',
  label: '子工单与层级关系'
}];
export default function Production() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u751F\u4EA7\u2014\u2014\u5DE5\u5355\u5C31\u662F\u6218\u573A",
    firstQuestion: "\u6211\u62FF\u5230\u4E00\u5F20\u5DE5\u5355\uFF0C\u73B0\u5728\u8BE5\u600E\u4E48\u64CD\u4F5C\uFF1F\u8FD9\u4E9B\u6309\u94AE\u662F\u4EC0\u4E48\u610F\u601D\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "status-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u5DE5\u5355\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: statusChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: statusColumns,
    data: statusData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "daily-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u65E5\u5E38\u64CD\u4F5C\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: dailyFlowChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "material"
  }, /*#__PURE__*/React.createElement("h2", null, "\u9886\u6599\u3001\u9000\u6599\u3001\u8865\u6599"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: materialColumns,
    data: materialData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "ecn"
  }, /*#__PURE__*/React.createElement("h2", null, "ECN \u5DE5\u7A0B\u53D8\u66F4"), /*#__PURE__*/React.createElement("blockquote", null, "\u8BBE\u8BA1\u6709\u53D8\u65F6\uFF0C\u8D70\u89C4\u8303\u7684\u53D8\u66F4\u6D41\u7A0B\uFF0C\u4E0D\u52A8\u539F\u5DE5\u5355\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: ecnChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "sub-order"
  }, /*#__PURE__*/React.createElement("h2", null, "\u5B50\u5DE5\u5355\u4E0E\u5C42\u7EA7\u5173\u7CFB"), /*#__PURE__*/React.createElement("blockquote", null, "\u4EA7\u54C1\u4E0E\u534A\u6210\u54C1\u4E4B\u95F4\u662F\u5C42\u7EA7\u5173\u7CFB\u3002\u4E00\u5F20\u7236\u5DE5\u5355\u53EF\u80FD\u6709\u591A\u5F20\u5B50\u5DE5\u5355\uFF0C\u5B50\u5DE5\u5355\u751F\u4EA7\u534A\u6210\u54C1\u4F9B\u7236\u5DE5\u5355\u4F7F\u7528\u3002"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u6279\u91CF\u542F\u52A8\u5B50\u5DE5\u5355"), "\uFF1A\u7236\u5DE5\u5355\u5F00\u5DE5\u540E\uFF0C\u53EF\u4E00\u952E\u542F\u52A8\u6240\u6709\u76F4\u5C5E\u5B50\u5DE5\u5355"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u9F50\u5957\u5206\u6790\u5C55\u5F00\u6574\u68F5\u6811"), "\uFF1A\u4E0D\u4EC5\u770B\u672C\u5DE5\u5355\uFF0C\u8FD8\u770B\u6240\u6709\u5B50\u5DE5\u5355\u7684\u6599\u662F\u5426\u9F50\u5957"))));
}